import {
  Component,
  OnDestroy,
  Input,
  forwardRef,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Injector,
  AfterContentInit,
} from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor, NgControl } from '@angular/forms';
import { Subscription } from 'rxjs';

@Component({
  selector: 'renci-field-validation',
  templateUrl: './field-validation.component.html',
  styleUrls: ['./field-validation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FieldValidationComponent),
      multi: true,
    },
  ],
})
export class FieldValidationComponent implements AfterContentInit, OnDestroy, ControlValueAccessor {
  @Input() messages;

  errors = [];

  private statusChange$: Subscription;

  constructor(private inj: Injector, private cdr: ChangeDetectorRef) {}

  writeValue(_: any): void {}
  registerOnChange(_: any): void {}
  registerOnTouched(_: any): void {}

  ngAfterContentInit() {
    const control = this.inj.get(NgControl);
    this.updateErrors(control);
    //  TODO: Investigate why statusChanges can be null
    this.statusChange$ = control.statusChanges.subscribe((status) => {
      this.updateErrors(control);
    });
  }

  ngOnDestroy() {
    if (this.statusChange$) {
      this.statusChange$.unsubscribe();
    }
  }

  private updateErrors(control: NgControl) {
    this.errors = [];
    if (control.status === 'INVALID' && control.errors) {
      for (const errorKey of Object.keys(control.errors)) {
        const error = control.errors[errorKey];
        if (this.messages && this.messages[control.name] && this.messages[control.name][errorKey]) {
          this.errors.push(this.messages[control.name][errorKey](error));
        } else if (this.messages && this.messages[errorKey]) {
          this.errors.push(this.messages[errorKey](error));
        } else if (errorKey === 'formError') {
          this.errors.push(control.errors.formError);
        } else {
          this.errors.push(`Validation error '${errorKey}' message not specified.`);
        }
      }
    }
    this.cdr.markForCheck();
  }
}
